const Ads = {
    init() {
        this.Add909Position();
    },
    Add909Position(){
        const adconfig = {
            pos:'909',
            id:'909',
            targetElement:'918',
            beforeOrAfter: 'insertBefore'
        }
        var elem909 = profads.ads2.insertAdElement(adconfig);
		if ($("#ads-pos-918").length > 0) {
			$(elem909).insertBefore($("#ads-pos-918"));
		}
    }
}
export { Ads }